// extracted by mini-css-extract-plugin
export default {"root":"WorkShiftChart_root__P3tmR","title":"WorkShiftChart_title__O2LBM","empty":"WorkShiftChart_empty__HFgPs","data":"WorkShiftChart_data__6iJfh"};